import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class TenantInterceptor implements HttpInterceptor
{
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
	{
		const tenantId = environment['tenant'] ?? '';

		const tenantReq = req.clone({
			setHeaders: {
				'__tenant': tenantId
			}
		});

		return next.handle(tenantReq);
	}
}
